














































































































import { Component, Watch, Vue, Prop, InjectReactive } from 'vue-property-decorator';
import { GQL_WorkRelationLeaveAndLayoffSave, GQL_AltinnLeaveAndLayoffDescriptionEnum } from '@/queries/global';
import { generateUID, WithUID } from '@/utils/utils';

@Component
export default class WorkRelationLeaveAndLayoff extends Vue {
  @InjectReactive() private editable!: boolean;
  @Prop({ type: Array, required: true }) private leaveAndLayoffs!: WithUID<GQL_WorkRelationLeaveAndLayoffSave>[];

  private get leaveAndLayoffsDisplay() {
    return this.leaveAndLayoffs.filter(x => !x._destroy);
  }

  @Watch('leaveAndLayoffs', { immediate: true })
  private assignUids(): void {
    this.leaveAndLayoffsDisplay
      .filter(x => { return !x.$_UID })
      .forEach(value => {
        value.$_UID = generateUID();
      });
  }

  private LeaveAndLayoffDescriptions = Object.keys(GQL_AltinnLeaveAndLayoffDescriptionEnum);

  private removeLeaveAndLayoff(leave: WithUID<GQL_WorkRelationLeaveAndLayoffSave>): void {
    if (leave.id) {
      this.$set(leave, '_destroy', true);
    } else {
      this.leaveAndLayoffs.splice(
        this.leaveAndLayoffs.indexOf(leave),
        1,
      );
    }
  }
}
